import axios from "axios";

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const InteractionHostelOrders = {
    async index(params) {
        get_token();
        try {
            return await axios.get(
                '/statement_hostel/commissions/accommodation_orders',
                { params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async get_distribution_persons_records(params) {
        get_token();
        try {
            return await axios.get(
                '/statement_hostel/commissions/accommodation_orders/get_distribution_persons_records',
                { params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
    async create(params) {
        get_token();
        try {
            return await axios.post(
                '/statement_hostel/commissions/accommodation_orders',
                { distributions_records: params }
            );
        } catch (e) {
            console.log("Error");
            return null;
        }
    },
}

export default InteractionHostelOrders;